import { useEffect, useState } from "react";
import { api } from "../lib/api";

/**
 * usePromo — fetches the active promotional offer from GET /api/promo (public,
 * backed by the admin-editable promo settings). Module-cached so the banner and
 * the pricing checkout share one fetch per session. Returns
 * { promo: { enabled, code, percent, headline, ends_at } | null, loading }.
 *
 * promo is null when no campaign is live, so callers can simply `if (!promo)`.
 */
let _cache = null;

export function usePromo() {
  const [state, setState] = useState(_cache || { promo: null, loading: true });

  useEffect(() => {
    if (_cache) return undefined;
    let alive = true;
    (async () => {
      let promo = null;
      try {
        const { data } = await api.get("/promo");
        if (data && data.enabled) promo = data;
      } catch {
        promo = null; // no live promo / endpoint error → banner stays hidden
      }
      _cache = { promo, loading: false };
      if (alive) setState(_cache);
    })();
    return () => {
      alive = false;
    };
  }, []);

  return state;
}

export default usePromo;
